import { OrderProfile } from '../types';
import { useOrderProfileStore } from '../store/useOrderProfileStore';
import { IOrderProfileService } from './IOrderProfileService';

export class OrderProfileServiceImpl implements IOrderProfileService {
  private orderProfileStore: typeof useOrderProfileStore;

  public constructor(orderProfileStore: typeof useOrderProfileStore) {
    this.orderProfileStore = orderProfileStore;
  }

  getOrderProfile(): OrderProfile | null {
    return this.orderProfileStore.getState().orderProfile;
  }

  public setPanelOpen(value: boolean): void {
    this.orderProfileStore.getState().setPanelOpen(value);
  }

  public setOrderProfile(orderProfile: OrderProfile): void {
    this.orderProfileStore.getState().setOrderProfile(orderProfile);
  }
}
